function BulkCostMappingService(ApiService) {
  'ngInject';

  const service = {};
    service.createMapping = function (bulkCostForm, orgId, callbackFunc) {
      let data = {
        asset_type: bulkCostForm.assetType,
        api_v1_account_id: bulkCostForm.assetAccount.id,
        narration: bulkCostForm.narration,
        depreciation_account_id: bulkCostForm.expenseAccount.id,
        effective_life: bulkCostForm.effectiveLife,
        bulk_cost_journals: bulkCostForm.bulk_cost_journals
      };
      ApiService.post(`/organizations/${orgId}/bulk_cost_mappings.json`, data, callbackFunc);
    };

    service.updateMapping = function(bulkCostForm, orgId, bulkmappingid, callbackFunc){
      let data = {
        asset_type: bulkCostForm.assetType,
        api_v1_account_id: bulkCostForm.assetAccount.id,
        narration: bulkCostForm.narration,
        depreciation_account_id: bulkCostForm.expenseAccount.id,
        effective_life: bulkCostForm.effectiveLife,
        bulk_cost_journals: bulkCostForm.bulk_cost_journals
      };
      ApiService.put(`/organizations/${orgId}/bulk_cost_mappings/${bulkmappingid}.json`, data, callbackFunc);
    };

    service.getMapping = function(orgId, bulkmappingid, callbackFunc){
      ApiService.get(`/organizations/${orgId}/bulk_cost_mappings/${bulkmappingid}.json`, callbackFunc);
  };

  service.getMappings = function(orgId, url, callbackFunc){
    ApiService.get(url, callbackFunc);
  };

  service.deleteMapping = function(mappingId, orgId, callbackFunc){
    ApiService.delete(`/organizations/${orgId}/bulk_cost_mappings/${mappingId}.json`, {}, callbackFunc);
  };

  service.getJournals = function(orgId, accountId, effectiveLife, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/bulk_cost_journals/history.json?account_id=${accountId}&effective_life=${effectiveLife}`, callbackFunc);
  };

  service.getBulkCostJournalCount = function(orgId, accountId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/bulk_cost_journals/bulk_cost_journal_count.json?account_id=${accountId}`, callbackFunc);
  };
  return service;
}

export default {
  name: 'BulkCostMappingService',
  fn: BulkCostMappingService
};
